<template>
  <v-btn
    :x-small="xSmallBtn"
    :small="smallBtn"
    :disabled="disabled"
    :style="{width: widthPX}"
    :color="color"
    :icon="isIconButton"
    class="mx-0"
    @click="goToAction"
    :block="block"
  >
    <v-icon :color="iconColor">{{icon}}</v-icon>
    &nbsp; {{text}}
  </v-btn>
</template>

<script>
export default {
  props: [
    'width',
    'icon',
    'iconColor',
    'color',
    'text',
    'routeName',
    'params',
    'disabled',
    'block',
    'size'
  ],
  computed: {
    isIconButton () {
      return !this.text
    },
    widthPX () {
      return this.width + 'px'
    },
    xSmallBtn () {
      return this.size === 'x-small'
    },
    smallBtn () {
      return this.size === 'small'
    }
  },
  methods: {
    goToAction () {
      if (this.routeName && this.params) {
        this.$router.push({ name: this.routeName, params: this.params })
        return
      }
      if (this.routeName) {
        this.$router.push({ name: this.routeName })
        return
      }
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
</style>
